import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { painPoints } from '../data/copy';
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-85" data-mp="2lpezgr1q3w56">
      <div className="mx-auto max-w-4xl" data-id="element-86" data-mp="26xmt34jwpsfl">
        <header className="text-center" data-id="element-87" data-mp="26wlfotff4tup">
          <h2 className="font-display text-[22px] font-bold leading-tight sm:text-5xl" style={{
          fontSize: "21px"
        }} data-id="element-88" data-mp="2bwr0pqr6ni3t">¿Cuántas consultas más terminan con "hay que esperar" porque el médico no tiene tus datos?</h2>
          <p className="mx-auto mt-6 max-w-3xl font-semibold text-slate-300" data-id="element-89" data-mp="220wd0h83qwu6">Sos una madre que lo da todo. Pero olvidas qué preguntar y salís sin entender los próximos pasos.</p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-90" data-mp="1szptdza5p5wp">No es falta de esfuerzo. Es que te faltaba un sistema.</p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-91" data-mp="3ibi729z2rv58">
          {painPoints.map((point, index) => <Reveal key={point} variant="left" delay={index * 50} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-92" data-mp="3nc5wwsbki5xv" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-93" data-mp="1u1tyit6ogigv" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-94" data-mp="27sqpygovatmc">{point}</p>
            </Reveal>)}
        </div>
        <p className="mt-12 text-center font-display text-[20px] font-bold italic text-brand-gold sm:text-3xl" style={{
        fontSize: "17px"
      }} data-id="element-95" data-mp="23r562bdx1f2n">¿Y si pudieras llegar preparada desde mañana mismo, con la carpeta ordenada y tus preguntas listas?</p>
      </div>
    </section>;
}